
import EnglishFlagIcon from '../../icons/EnglishFlagIcon';
import IcelandFlagIcon from '../../icons/IcelandFlagIcon';
import NorwayFlagIcon from '../../icons/NorwayFlagIcon';
import SpanishFlagIcon from '../../icons/SpanishFlagIcon';
import DanishFlagIcon from '../../icons/DanishFlagIcon';

export type CountryCodeType = 'en' | 'is' | 'es' | 'nb' | 'dk';

const Flag = ({ code, onClick }: { code: CountryCodeType; onClick?: () => void }) => {
  switch (code) {
    case 'en':
      return <EnglishFlagIcon size={20} onClick={onClick} />;
    case 'is':
      return <IcelandFlagIcon size={20} onClick={onClick} />;
    case 'es':
      return <SpanishFlagIcon size={20} onClick={onClick} />;
    case 'nb':
      return <NorwayFlagIcon size={20} onClick={onClick} />;
    case 'dk':
      return <DanishFlagIcon size={20} onClick={onClick} />;
    default:
      return null;
  }
};

export default Flag;
